import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SharedContextValue {
    currentMenu?: string;
    [key: string]: any;
}

interface SharedContextType {
    sharedContext: SharedContextValue | null;
    handleContextChange: (newContext: SharedContextValue) => void;
}

const SharedContext = createContext<SharedContextType | undefined>(undefined);

interface SharedObjectProviderProps {
    children: ReactNode;
}

export const SharedObjectProvider: React.FC<SharedObjectProviderProps> = ({ children }) => {
    const [sharedContext, setSharedContext] = useState<SharedContextValue | null>(null);

    const handleContextChange = (newContext: SharedContextValue) => {
        setSharedContext(newContext);
    };

    return <SharedContext.Provider value={{ sharedContext, handleContextChange }}>{children}</SharedContext.Provider>;
};

export const useSharedContext = () => {
    const context = useContext(SharedContext);
    if (!context) {
        throw new Error('useSharedContext must be used within a SharedObjectProvider');
    }
    return context;
};